import clsx from 'clsx';
import Footer from 'components/organisms/Footer/Footer';
import Header from 'components/organisms/Header/Header';
import LandingPageCta from 'components/organisms/LandingPageCta/LandingPageCta';
import React from 'react';
import classes from './PageContainer.module.scss';
import useScrollState from './useScrollState';

export interface Props {
  children?: React.ReactNode;
  withoutHeader?: boolean;
  withoutHeaderOnMobile?: boolean;
  withoutSubNav?: boolean;
  withoutFooter?: boolean;
  withoutFooterOnMobile?: boolean;
  fadedPageBg?: boolean;
  fadedPageBgMobile?: boolean;
  isLandingPage?: boolean;
  allowStickyChildren?: boolean;
  brandTakeover?: boolean;
}

export default function PageContainer({
  children,
  withoutHeader,
  withoutHeaderOnMobile,
  withoutSubNav,
  withoutFooter,
  withoutFooterOnMobile,
  fadedPageBg,
  fadedPageBgMobile,
  isLandingPage,
  allowStickyChildren,
  brandTakeover,
}: Props): React.ReactElement {
  const scrollState = useScrollState();

  return (
    <div
      className={clsx(
        classes.root,
        isLandingPage && scrollState,
        isLandingPage && 'isLandingPage',
        brandTakeover && classes.forceWhiteBackground,
      )}
    >
      {!withoutHeader &&
        (withoutHeaderOnMobile ? (
          <div className={classes.hideOnMobile}>
            <Header
              isLandingPage={isLandingPage}
              withoutSubNav={withoutSubNav}
              brandTakeover={brandTakeover}
            />
          </div>
        ) : (
          <Header
            isLandingPage={isLandingPage}
            withoutSubNav={withoutSubNav}
            brandTakeover={brandTakeover}
          />
        ))}
      <div
        className={clsx(
          classes.content,
          allowStickyChildren && classes.allowStickyChildren,
          fadedPageBg && 'fadedPageBg',
          fadedPageBgMobile && 'fadedPageBgMobile',
        )}
      >
        {children}
        {isLandingPage && <LandingPageCta />}
      </div>
      {!withoutFooter &&
        (withoutFooterOnMobile ? (
          <div className={classes.hideOnMobile}>
            <Footer />
          </div>
        ) : (
          <Footer />
        ))}
    </div>
  );
}
